var _style, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPwCFunctIconsHelpQuestionFillBlackRgb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 104 99",
    style: {
      enableBackground: "new 0 0 104 99"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#2D2D2D;}\r\n\t.st1{fill:#464646;}\r\n\t.st2{fill:#7D7D7D;}\r\n\t.st3{fill:#D04A02;}\r\n\t.st4{fill:#E0301E;}\r\n\t.st5{fill:#FFFFFF;}\r\n\t.st6{fill:#DB536A;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52,13.5c-19.9,0-36,16.1-36,36c0,19.9,16.1,36,36,36c19.9,0,36-16.1,36-36C88,29.6,71.9,13.5,52,13.5z M55.5,67.5h-7.7 v-7.6h7.7V67.5z M63.5,44.9c-0.4,1-0.9,1.9-1.5,2.6c-0.6,0.7-1.3,1.3-2,1.8c-0.7,0.5-1.4,1-2.1,1.5c-0.7,0.5-1.2,1.1-1.7,1.7 c-0.5,0.7-0.8,1.5-1,2.5V57h-6.6v-2.2c0.1-1.4,0.4-2.6,0.8-3.5c0.4-1,1-1.8,1.6-2.4c0.6-0.7,1.2-1.3,1.9-1.7c0.7-0.5,1.3-1,1.8-1.5 c0.6-0.5,1-1,1.4-1.6c0.3-0.6,0.5-1.3,0.5-2.2c0-1.5-0.4-2.6-1.1-3.3c-0.7-0.7-1.8-1.1-3.1-1.1c-0.9,0-1.7,0.2-2.3,0.5 c-0.6,0.3-1.2,0.8-1.6,1.4c-0.4,0.6-0.7,1.3-0.9,2c-0.2,0.8-0.3,1.6-0.3,2.5h-7.2c0-1.8,0.3-3.4,0.9-4.9c0.6-1.5,1.4-2.8,2.4-3.8 c1-1.1,2.3-1.9,3.7-2.5c1.5-0.6,3.1-0.9,4.9-0.9c2.3,0,4.3,0.3,5.8,1c1.6,0.6,2.8,1.4,3.8,2.4c1,1,1.6,2,2,3.1 c0.4,1.1,0.6,2.1,0.6,3.1C64.1,42.6,63.9,43.9,63.5,44.9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPwCFunctIconsHelpQuestionFillBlackRgb);
export default __webpack_public_path__ + "static/media/PwC_Funct_Icons_HelpQuestion_Fill_Black_RGB.e4697cfc62cc7b9867a009ca3b44fd6d.svg";
export { ForwardRef as ReactComponent };